import React, { useState } from 'react'
import { setNotification } from '../../shared/components/ui-widgets/uiWidgetsSlice'
import { RtkQueryHelper } from '../../../api/shared/RtkQueryHelper'
import { useAppDispatch } from '../../../app/hooks'
import { Box, Button, Dialog, DialogContent, DialogTitle, Grid, TextField, Typography } from '@mui/material'
import LoadingComponent from '../../shared/components/ui-widgets/LoadingComponent'
import ButtonLoadingComponent from '../../shared/components/ui-widgets/ButtonLoadingComponent'
import { generateAndSendOtpMutation } from '../../../api/two-fa/twoFAApi'

interface OtpComponentProps {
  assetHolderId: number
  isLoading: boolean
  actionName: string
  authenticatorConfigured: boolean | null
  executeAction: (otp: string) => void
  disabled: boolean
}

const OtpComponent: React.FC<OtpComponentProps> = (props: OtpComponentProps) => {
  const { executeAction, assetHolderId, actionName, isLoading, authenticatorConfigured, disabled } = props

  const dispatch = useAppDispatch()

  const [isDialogOpen, toggleDialog] = useState<boolean>(false)
  const [otp, setOtp] = useState<string>('')

  const [apiGenerateAndSendOtp, { isLoading: generatingOtp, isSuccess }] = generateAndSendOtpMutation()

  const handleGenerateAndSendOtp = (): void => {
    apiGenerateAndSendOtp(assetHolderId)
      .unwrap()
      .catch((err) => {
        dispatch(setNotification({ open: true, severity: 'error', message: RtkQueryHelper.mapResponseError(err) }))
      })
  }

  const openDialog = (): void => {
    toggleDialog(true)
    handleGenerateAndSendOtp()
  }

  const processAction = (): void => {
    executeAction(otp)
  }

  const validOtp = (): boolean => {
    return otp.length >= 6
  }

  return (
    <>
      <Button
        variant={'contained'}
        color={'primary'}
        disabled={disabled}
        onClick={() => {
          openDialog()
        }}
      >
        {actionName}
      </Button>

      <Dialog
        open={isDialogOpen}
        maxWidth={'xs'}
        fullWidth={true}
        disableEscapeKeyDown={true}
        onClose={() => {
          toggleDialog(false)
        }}
      >
        <DialogTitle></DialogTitle>

        <DialogContent sx={{ p: 4 }}>
          {generatingOtp && <LoadingComponent/>}
          {isSuccess &&
            <>
              <Typography variant={'subtitle1'} sx={{ mb: 2 }}>
                {authenticatorConfigured === null
                  ? 'Please enter the OTP code displayed on your authenticator app or sent to your your email address.'
                  : authenticatorConfigured
                    ? 'Please enter the verification code (OTP) displayed on your authenticator app:'
                    : 'Please enter the OTP sent to your email address:'
                }
              </Typography>

              <Grid container spacing={2}>
                <Grid item md={12}>
                  <TextField
                    label={'OTP'}
                    name={'otp'}
                    type={'text'}
                    sx={{ width: '100%' }}
                    placeholder={'OTP'}
                    focused={true}
                    onChange={(event) => {
                      setOtp(event.target.value)
                    }}
                  />
                </Grid>
                <Grid item>
                  <Button
                    variant={'contained'}
                    type="button"
                    disabled={isLoading || !validOtp()}
                    onClick={() => {
                      processAction()
                    }}
                  >
                    Verify
                    {(isLoading) && <ButtonLoadingComponent/>}
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant={'outlined'}
                    type="button"
                    disabled={isLoading}
                    onClick={() => {
                      toggleDialog(false)
                    }}
                    sx={{ ml: 2 }}
                  >
                    Cancel
                  </Button>
                </Grid>
              </Grid>
            </>
          }

          <Box>

          </Box>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default OtpComponent
